import * as React from "react"
import { Box, Button, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import {
    appliedFilters,
    canSearch,
    coverage,
    coverageTotal,
    currentPage,
    hasSearched,
    isLoadingFilters,
    qualityFlags,
    searchText,
    selectedBrands,
    selectedSites,
    tableData,
    totalCount,
} from "../@signals"


export default function ScrapingDataReviewFiltersFooter() {
    const handleSearch = () => {
        currentPage.value = 0
        isLoadingFilters.value = true
    }

    const handleClear = () => {
        selectedSites.value = []
        selectedBrands.value = []
        searchText.value = ''
        qualityFlags.value = {}
        appliedFilters.value = null
        hasSearched.value = false
        tableData.value = []
        totalCount.value = 0
        coverage.value = null
        coverageTotal.value = 0
        currentPage.value = 0
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {!canSearch.value && (
                <Typography variant="caption" sx={{ color: '#9ca3af', mr: 1 }}>
                    Pick a customer and at least one site to search
                </Typography>
            )}
            <Button
                variant="outlined"
                size="small"
                onClick={handleClear}
                disabled={isLoadingFilters.value}
            >
                Clear
            </Button>
            <Button
                variant="contained"
                size="small"
                onClick={handleSearch}
                disabled={!canSearch.value || isLoadingFilters.value}
                startIcon={isLoadingFilters.value ? <IconSeeker icon="spinner" spin="true" /> : <IconSeeker icon="search" />}
            >
                Search
            </Button>
        </Box>
    )
}
